import { render } from "./HollandResultPage.vue?vue&type=template&id=e831c8c4&scoped=true"
import script from "./HollandResultPage.vue?vue&type=script&lang=js"
export * from "./HollandResultPage.vue?vue&type=script&lang=js"

import "./HollandResultPage.vue?vue&type=style&index=0&id=e831c8c4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e831c8c4"]])

export default __exports__